import { StaticsAnalysis } from './StaticsAnalysis'

import type { TEventName, TEventParams } from './types'

export class WebStaticsAnalysis extends StaticsAnalysis {
  private userId = ''

  private email_sha256 = ''

  getDataLayer() {
    const dataLayer = (window as any)?.dataLayer as Record<string, any>[]
    if (!dataLayer) {
      ;(window as any).dataLayer = []
      return
    }
    return dataLayer
  }

  public async updateUserId(userId: string) {
    const dataLayer = this.getDataLayer()
    if (!dataLayer) {
      return
    }
    dataLayer.push({
      user_id: userId,
    })
    this.userId = userId
  }

  public async updateEmail(email_sha256: string) {
    const dataLayer = this.getDataLayer()
    if (!dataLayer) {
      return
    }

    this.email_sha256 = email_sha256
    dataLayer.push({
      email_sha256,
      user_data: {
        email_address: this.email_sha256,
      },
    })
  }

  public track = (eventName: TEventName, eventParams?: TEventParams) => {
    const windowDataLayer = this.getDataLayer()
    if (!windowDataLayer) {
      return
    }

    if (eventParams?.user_id) {
      this.updateUserId(eventParams?.user_id)
    }

    if (eventParams?.email_sha256) {
      this.updateEmail(eventParams?.email_sha256)
    }

    const dataLayer: Record<string, any> = {
      event: eventName,
      ...eventParams,
    }

    if (this.userId) {
      dataLayer.user_id = this.userId
      dataLayer.email_sha256 = this.email_sha256
      dataLayer.user_data = {
        email_address: this.email_sha256,
      }
    }
    windowDataLayer.push(dataLayer)

    const resetParams: typeof eventParams = {}

    if (eventParams) {
      for (const key in eventParams) {
        if (!['user_id', 'email_sha256', 'user_data'].includes(key)) {
          resetParams[key] = null
        }
      }
    }

    /* 上报后先把所有参数先清空 */
    windowDataLayer.push(resetParams)
  }
}
